// extracted by mini-css-extract-plugin
module.exports = {"container":"WebDirectory_container__3EOG6","directory":"WebDirectory_directory__1u1K3","content":"WebDirectory_content__360Ng"};